import * as openpgp from "openpgp";

// Some exported keys omit the blank line after the armor header; openpgp.js insists on it.
const normaliseArmor = (armored) => String(armored || "").trim().replace(/\r\n/g, "\n")
  .replace(/^(-----BEGIN PGP PUBLIC KEY BLOCK-----)\n(?!(?:[A-Za-z-]+: .*\n)*\n)/, "$1\n\n");

// Encrypts the customer's delivery details in the browser with the shop's PGP public key.
// Plain text never leaves the device — the server only ever receives the armored PGP message.
export const encryptForShop = async (armoredKey, fields) => {
  const lines = [
    `Name: ${fields.name}`,
    `Address: ${fields.address}`,
    `Town/City: ${fields.city}`,
    `Postcode: ${fields.postcode}`,
    fields.notes ? `Delivery notes: ${fields.notes}` : null,
  ].filter(Boolean);
  const publicKey = await openpgp.readKey({ armoredKey: normaliseArmor(armoredKey) });
  const message = await openpgp.createMessage({ text: lines.join("\n") });
  return openpgp.encrypt({ message, encryptionKeys: publicKey });
};

export const fetchMainShopKey = async () => {
  const res = await fetch("/pgp-public.asc", { cache: "force-cache" });
  if (!res.ok) throw new Error("key unavailable");
  const text = await res.text();
  if (!/BEGIN PGP PUBLIC KEY BLOCK/.test(text)) throw new Error("key unavailable");
  return text;
};
